import * as kpisServices from '@/services/kpis.js'
import { fetchDataWithCache } from '@/helpers/cacheHelper'
import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_SUGGESTED_PRODUCTS_OPPORTUNITIES, QUERY_GET_HOME_CONSUMERS_DISTRIBUTION } from '../graphql'
import { QUERY_PRODUCTS_BY_SKUS } from '@/modules/produtos/faixa-precos/graphql'

export default {
  async getHomeConsumersDistribution({ rootState, commit }, variables) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await apolloProvider.defaultClient
        .query({
          query: QUERY_GET_HOME_CONSUMERS_DISTRIBUTION,
          variables: {
            date: variables,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: clientsActivityClusters }) => {
          return clientsActivityClusters
        })
      return response.clientsActivityClusters
    }

    const clientsActivityClusters = await fetchDataWithCache('clientsActivityClusters', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_HOME_CONSUMERS_DISTRIBUTION', clientsActivityClusters)
  },
  async getSuggestedProductsOpportunities({ rootState, commit }, variables) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await apolloProvider.defaultClient
        .query({
          query: QUERY_SUGGESTED_PRODUCTS_OPPORTUNITIES,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: suggestedProductsOpportunities }) => {
          return suggestedProductsOpportunities
        })
      return response.suggestedProductsOpportunities
    }

    const suggestedProductsOpportunities = await fetchDataWithCache(
      'suggestedProductsOpportunities',
      fetchFunction,
      lastUpdate?.last_updated,
      lastUpdate?.processing_uuid
    )

    commit('SET_SUGGESTED_PRODUCTS_OPPORTUNITIES', suggestedProductsOpportunities)
  },
  async getProductsBySKU({ commit }, variables) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .query({
          query: QUERY_PRODUCTS_BY_SKUS,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              products: { products },
            },
          }) => {
            resolve(products)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  async homeClientesPerdidos({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.clientesPerdidos(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeClientesPerdidos', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'clientesPerdidos', data, state })
  },
  async homeFaturamento({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.faturamento(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeFaturamento', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'faturamento', data, state })
  },
  async homeCupons({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.cupons(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeCupons', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'cupons', data, state })
  },
  async homeLastYearCoupons({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.cupons(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeLastYearCoupons', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'cuponsLastYear', data, state })
  },
  async homeFaturamentoDta({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.faturamentoDta(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeFaturamentoDta', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'faturamentoDta', data, state })
  },
  async homeTicketMedio({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.ticketMedio(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homeTicketMedio', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'ticketMedio', data, state })
  },
  async homeClientesCadastrados({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.clientesCadastrados({ ...filter, fidelidade: '1' })
      return response.data
    }

    const data = await fetchDataWithCache('homeClientesCadastrados', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'clientesCadastrados', data, state })
  },
  async homeTotalClientesCadastrados({ rootState, state, commit }) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.clientesCadastrados({ fidelidade: ['1', '0'] })
      return response.data
    }

    const data = await fetchDataWithCache('homeTotalClientesCadastrados', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'totalClientesCadastrados', data, state })
  },
  async homeClientesAtivos({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.clientesAtivos({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeClientesAtivos', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'clientesAtivos', data, state })
  },
  async homePercentualFaturamentoFidelidade({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.percentualFaturamentoFidelidade(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homePercentualFaturamentoFidelidade', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'percentualFaturamentoFidelidade', data, state })
  },
  async mariaPercentualFaturamentoFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.percentualFaturamentoFidelidade(filter)
    const highestPercentageIdentified = Array.isArray(data)
      ? data.reduce((prev, current) => (prev.PER_FATURAMENTO_FIDELIDADE > current.PER_FATURAMENTO_FIDELIDADE ? prev : current))
      : data
    commit('SET_OBJECT', { name: 'mariaPercentualFaturamentoFidelidade', data: highestPercentageIdentified, state })
  },
  async homeTicketMedioFidelidade({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.ticketMedio({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeTicketMedioFidelidade', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'ticketMedioFidelidade', data, state })
  },
  async homeTicketMedioForaClube({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.ticketMedio({ fidelidade: '0', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeTicketMedioForaClube', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'ticketMedioForaClube', data, state })
  },
  async homePercentualTicketMedioFidelidade({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.percentualTicketMedioFidelidade(filter)
      return response.data
    }

    const data = await fetchDataWithCache('homePercentualTicketMedioFidelidade', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'percentualTicketMedioFidelidade', data, state })
  },
  async homePercentualTicketMedioFidelidadeMesAnterior({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.percentualTicketMedioFidelidade(filter)
      return response.data
    }

    const data = await fetchDataWithCache(
      'homePercentualTicketMedioFidelidadeMesAnterior',
      fetchFunction,
      lastUpdate?.last_updated,
      lastUpdate?.processing_uuid
    )

    commit('SET_OBJECT', { name: 'percentualTicketMedioFidelidadeMesAnterior', data, state })
  },
  async homeMediaComprasFidelidade({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.mediaCompras({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeMediaComprasFidelidade', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'mediaComprasFidelidade', data, state })
  },
  async homeMediaComprasFidelidadeAnoAnterior({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.mediaCompras({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeMediaComprasFidelidadeAnoAnterior', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'mediaComprasFidelidadeAnoAnterior', data, state })
  },
  async homeGastoMedioFidelidade({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.gastoMedio({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeGastoMedioFidelidade', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'gastoMedioFidelidade', data, state })
  },
  async homeGastoMedioFidelidadeAnoAnterior({ rootState, state, commit }, filter) {
    const { lastUpdate } = rootState

    const fetchFunction = async () => {
      const response = await kpisServices.gastoMedio({ fidelidade: '1', ...filter })
      return response.data
    }

    const data = await fetchDataWithCache('homeGastoMedioFidelidadeAnoAnterior', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)

    commit('SET_OBJECT', { name: 'gastoMedioFidelidadeAnoAnterior', data, state })
  },

  async primeiroValorCadastrosTotal({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'primeiroValorCadastrosTotal', data, state })
  },
  async primeiroValorCadastrosOntem({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'primeiroValorCadastrosOntem', data, state })
  },
  async primeiroValorCadastrosSemanaAtual({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'primeiroValorCadastrosSemanaAtual', data, state })
  },
  async primeiroValorCadastrosMesAtual({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'primeiroValorCadastrosMesAtual', data, state })
  },
  async primeiroValorPerfilDemografico({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados({ ...filter, tipo_pessoa: 'F', group_field: ['faixa_etaria', 'genero'] })
    commit('SET_OBJECT', { name: 'primeiroValorPerfilDemografico', data, state })
  },
}
